import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/transparencia-e-seguranca")({
  head: () => ({
    meta: [
      { title: "Transparência e Segurança - P2 PRO | Compromisso com Você" },
      { name: "description", content: "Conheça nossas práticas de segurança e nosso compromisso com a transparência. Veja como protegemos sua operação de revenda e garantimos estabilidade." },
    ],
  }),
  component: () => (
    <SEOPage
      category="Institucional"
      title="TRANSPARÊNCIA E SEGURANÇA: NOSSO DNA"
      subtitle="Construímos relações baseadas na confiança e em uma infraestrutura tecnológica inabalável."
      introParagraphs={[
        "No mercado de tecnologia e streaming, a segurança não é um opcional, é o alicerce de qualquer negócio sério. Na P2 PRO, adotamos uma política de Transparência e Segurança total para garantir que nossos revendedores possam dormir tranquilos, sabendo que sua infraestrutura e seus dados estão protegidos pelas melhores tecnologias disponíveis em 2026.",
        "Nossa rede é monitorada em tempo real por sistemas de detecção de intrusão e mitigação de ataques DDoS, garantindo que o sinal permaneça online mesmo diante de tentativas de sabotagem externa. Além da segurança técnica, prezamos pela transparência administrativa: você tem acesso a logs completos de todas as suas atividades dentro do nosso ecossistema.",
        "Acreditamos que um parceiro bem informado é um parceiro que cresce. Por isso, comunicamos proativamente qualquer manutenção programada ou atualização de sistema, garantindo que você possa gerenciar as expectativas do seu cliente final com clareza e profissionalismo."
      ]}
      benefits={[
        {
          title: "Monitoramento Proativo",
          description: "Nossa equipe detecta e resolve potenciais problemas antes mesmo que eles afetem sua rede de clientes.",
        },
        {
          title: "Proteção Anti-DDoS",
          description: "Infraestrutura resiliente capaz de absorver e neutralizar ataques de negação de serviço massivos.",
        },
        {
          title: "Backups Redundantes",
          description: "Sincronização de dados em múltiplos data centers para garantir zero perda de informações em casos críticos.",
        }
      ]}
      howItWorks={[
        { title: "Auditoria", description: "Realizamos testes de estresse semanais em nossos servidores para garantir a máxima estabilidade." },
        { title: "Criptografia", description: "Todos os dados sensíveis dos revendedores são criptografados com padrões bancários (AES-256)." },
        { title: "Comunicação", description: "Canais de status oficiais para você acompanhar a saúde da nossa rede em tempo real." },
        { title: "Atualização", description: "Patchs de segurança aplicados automaticamente em toda a nossa frota de servidores." }
      ]}
      diferenciais={[
        { title: "Sinal Limpo", description: "Tecnologia que impede a interceptação ou degradação do sinal durante a transmissão." },
        { title: "Suporte Ético", description: "Respeito total às regras de mercado e ao relacionamento comercial com nossos parceiros." },
        { title: "Data Centers Tier 3", description: "Hospedagem em locais com alta redundância de energia e conectividade de fibra óptica." }
      ]}
      faq={[
        {
          question: "Meus créditos estão seguros?",
          answer: "Sim, o saldo do seu painel é protegido por múltiplas camadas de autenticação e backups diários."
        },
        {
          question: "Como vocês lidam com quedas de sinal?",
          answer: "Nossa rede possui redundância automática. Se um servidor falha, o tráfego é redirecionado instantaneamente para outro nó da rede."
        },
        {
          question: "O suporte pode acessar minha conta?",
          answer: "Apenas com sua autorização expressa e para fins estritos de suporte técnico documentado."
        }
      ]}
      breadcrumbs={[
        { label: "Institucional", href: "/" },
        { label: "Transparência", href: "/transparencia-e-seguranca" }
      ]}
    />
  ),
});
